import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdCloseCircle } from 'react-icons/io';
import MyTreeView from './TreeView';
import { fetchHospitalBlockData } from '@utils/deviceUtils';
import { useAppSelector } from '@store/hooks';

type TreeViewDataType = Record<string, any>[];

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
  }

const HierarchyModalPopUp: React.FC<ModalProps> = ({
    isOpen,
    onClose,
}) => {
    if (!isOpen) {
        return null;
    }

    const [treeViewData, setTreeViewData] = useState<TreeViewDataType>([]);
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const { t } = useTranslation();

    const fetchData = async () => {
        try {
            const hospitalBlock =
                await fetchHospitalBlockData(loggedInUserTenantID); // Await the promise
            setTreeViewData(hospitalBlock); // Set the fetched data to the state
        } catch (error) {
            console.error('Error fetching hospital block data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
            <div className="bg-white p-4 rounded-lg shadow-lg text-center relative hierarchy-modal">
                <h1 className="absolute top-0 left-0 mt-2 ms-3 text-lg font-bold">
                    {t('management.hospital.hospital_data_hierarchy')}
                </h1>
                <button
                    className="absolute top-0 right-0 mt-2 mr-2 !text-black"
                    onClick={onClose}
                    aria-label="close"
                >
                    <IoMdCloseCircle className="!text-lg" />
                </button>
                <div className="my-4">
                    <MyTreeView
                        data={treeViewData}
                        isDisabled={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default HierarchyModalPopUp;
